
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DiscountingPolicyGrid extends Serenity.EntityGrid<DiscountingPolicyRow, any> {
        protected getColumnsKey() { return 'OMS.DiscountingPolicy'; }
        protected getDialogType() { return DiscountingPolicyDialog; }
        protected getIdProperty() { return DiscountingPolicyRow.idProperty; }
        protected getInsertPermission() { return DiscountingPolicyRow.insertPermission; }
        protected getLocalTextPrefix() { return DiscountingPolicyRow.localTextPrefix; }
        protected getService() { return DiscountingPolicyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}